import React from 'react';
import Footer from "./Footer";
import '../styles/About.css';

const About = () => {
  return (
    <>
  <div className="about-page">
    <div className="about-container">
      {/* Hero Section */}
      <section className="about-hero">
        <h1>🙋 Over ons</h1>
        <p className="hero-tagline">Wij maken gamen leuk, gratis en verantwoord.</p>
        <div className="hero-description">
          <p>Firgoquast is een Noors platform voor sociale casinospellen – gemaakt voor iedereen die van spellen houdt maar een veilige en geldvrije ervaring wil.</p>
        </div>
      </section>

      {/* Features Section */}
      <section className="features-section">
        <h2>Wij bieden een breed scala aan casinogeïnspireerde spellen die:</h2>
        <div className="features-grid">
          <div className="feature-card">
            <span className="feature-icon">🆓</span>
            <h3>100% gratis te spelen</h3>
          </div>
          <div className="feature-card">
            <span className="feature-icon">🎲</span>
            <h3>Voor amusementsdoeleinden</h3>
          </div>
          <div className="feature-card">
            <span className="feature-icon">❌</span>
            <h3>Zonder echt geld, inzetten of prijzen</h3>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="values-section">
        <h2>🎯 Waar wij voor staan</h2>
        <div className="values-grid">
          <div className="value-card">
            <div className="value-header">
              <span className="value-icon">🎮</span>
              <h3>Spelen zonder druk</h3>
            </div>
            <p>Wij geloven dat gamen leuk moet zijn – zonder risico, verlies of geldgebruik.</p>
          </div>

          <div className="value-card">
            <div className="value-header">
              <span className="value-icon">🔞</span>
              <h3>Voor volwassenen (18+)</h3>
            </div>
            <p>Ons platform is alleen bedoeld voor volwassenen. Wij promoten verantwoord gebruik en bevatten geen elementen van gokken.</p>
          </div>

          <div className="value-card">
            <div className="value-header">
              <span className="value-icon">🛡️</span>
              <h3>Veiligheid en transparantie</h3>
            </div>
            <p>Wij verzamelen geen persoonlijke betaalinformatie. Alle verwerkte gegevens zijn anoniem en in overeenstemming met de AVG en de Noorse wetgeving.</p>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="contact-section">
        <h2>📍 Onze locatie</h2>
        <div className="contact-card">
          <div className="company-info">
            <h3>Firgoquast AS</h3>
            <p>Dronning Eufemias gate 16</p>
            <p>0191 Oslo, Noorwegen</p>
          </div>
          <div className="contact-details">
            <p><span>📧</span> E-mail: <a href="mailto:meister@gmail.com">meister@gmail.com</a></p>
            <p><span>📞</span> Telefoon: <a href="tel:+4722837010">+47 22 83 70 10</a></p>
          </div>
        </div>
      </section>
    </div>
  </div>
  <Footer />
</>

  );
};

export default About;
